// src/components/Sidebar.js
import React, { useState } from 'react';
import './styles/Sidebar.css';
import { BiAnalyse } from 'react-icons/bi';
import { FaChevronDown, FaChevronRight, FaFileAlt, FaSearch, FaBook, FaChalkboardTeacher, FaChevronLeft, FaChevronCircleLeft, FaEdit, FaBalanceScale, FaRegClone, FaGlobe } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandVocabulary, setExpandVocabulary] = useState(true); // Mặc định mở rộng
  const [expandTranslateText, setExpandTranslateText] = useState(true); // Mặc định mở rộng
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    if (!isCollapsed) {
      setExpandVocabulary(false);
      setExpandTranslateText(false);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        {isCollapsed ? <FaChevronRight size={12} /> : <FaChevronLeft size={12} />}
      </div>
      
      <ul>
        {/* Vocabulary Section */}
        <li 
          onClick={() => !isCollapsed && setExpandVocabulary(!expandVocabulary)} 
          className={`section-title ${expandVocabulary ? 'active' : ''}`}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaBook className="icon" style={{ marginRight: '10px' }} />
            {!isCollapsed && <span>Old to New Words</span>}
          </div>
          {!isCollapsed && (
            expandVocabulary ? <FaChevronDown className="arrow-icon" /> : <FaChevronRight className="arrow-icon" />
          )}
        </li>
        <div className={`sub-menu ${expandVocabulary ? 'expanded' : ''}`}>
          <li
            onClick={() => navigate('/search-word')}
            className={`sub-menu-item ${isActive('/search-word') ? 'active' : ''}`}
          >
            <FaSearch className="icon" />
            {!isCollapsed && <span>Search Word</span>}
          </li>
          <li
            onClick={() => navigate('/vocabulary-list')}
            className={`sub-menu-item ${isActive('/vocabulary-list') ? 'active' : ''}`}
          >
            <FaBook className="icon" />
            {!isCollapsed && <span>Vocabulary List</span>}
          </li>
          <li
            onClick={() => navigate('/learning-board')}
            className={`sub-menu-item ${isActive('/learning-board') ? 'active' : ''}`}
          >
            <FaChalkboardTeacher className="icon" />
            {!isCollapsed && <span>Learning Board</span>}
          </li>
          <li
            onClick={() => navigate('/vocabulary-review')}
            className={`sub-menu-item ${isActive('/vocabulary-review') ? 'active' : ''}`}
          >
            <FaRegClone className="icon" />
            {!isCollapsed && <span>Vocabulary Review</span>}
          </li>
        </div>
        <li
          onClick={() => navigate('/compare-words')}
          className={`section-title ${isActive('/compare-words') ? 'active' : ''}`}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaBalanceScale className="icon" style={{ marginRight: '10px' }} />
            {!isCollapsed && <span>Compare Words</span>}
          </div>
        </li>
        {/* Marklive Section - now at top level */}
        <li
          onClick={() => navigate('/marklive')}
          className={`section-title ${isActive('/marklive') ? 'active' : ''}`}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaEdit className="icon" style={{ marginRight: '10px' }} />
            {!isCollapsed && <span>Marklive</span>}
          </div>
        </li>

        {/* Compare Words - top level */}


        {/* Translate Section */}
        <li 
          onClick={() => !isCollapsed && setExpandTranslateText(!expandTranslateText)}
          className={`section-title ${expandTranslateText ? 'active' : ''}`}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaGlobe className="icon" style={{ marginRight: '10px' }} />
            {!isCollapsed && <span>Translate</span>}
          </div>
          {!isCollapsed && (
            expandTranslateText ? <FaChevronDown className="arrow-icon" /> : <FaChevronRight className="arrow-icon" />
          )}
        </li>
        <div className={`sub-menu ${expandTranslateText ? 'expanded' : ''}`}>
          <li
            onClick={() => navigate('/translate-text')}
            className={`sub-menu-item ${isActive('/translate-text') ? 'active' : ''}`}
          >
            <FaGlobe className="icon" />
            {!isCollapsed && <span>Translate Text</span>}
          </li>
          <li
            onClick={() => navigate('/translate-file')}
            className={`sub-menu-item ${isActive('/translate-file') ? 'active' : ''}`}
          >
            <FaFileAlt className="icon" />
            {!isCollapsed && <span>Translate File</span>}
          </li>
        </div>
      </ul>
    </aside>
  );
};

export default Sidebar;